function objectKeys<Obj extends object>(obj: Obj): Array<keyof Obj> {
    return Object.keys(obj) as Array<keyof Obj>;
}

export default objectKeys;
